import { fqApiBypassHost } from "../../utils/http";

export const resolveCallers = {
    resolveIp: () => {
			return fetch(`${fqApiBypassHost}/ip`)
				.then(a => a.json())
				.then(({client_ip}) => ({clientIp: client_ip}));
		}
}
